// extracted by mini-css-extract-plugin
export default {"container":"InfoAlert_container__KdsnP","darkStyle":"InfoAlert_darkStyle__QnvqB","icon":"InfoAlert_icon__diyg-","alertText":"InfoAlert_alertText__3JqpM"};